import { RequestResult } from '@api/responseModels/requestResult';
import { WorkScheduleListResp } from '@api/responseModels/workSchedule/workScheduleListResponse';
import { WorkScheduleResp } from '@api/responseModels/workSchedule/workScheduleResponse';
import { WorkScheduleResourcesListResp } from '@api/responseModels/workSchedule/workSchedulesResourcesListResponse';

import { CRMAPIBase } from '../crmApiBase';

class WorksScheduleGroup extends CRMAPIBase {
    async getWorkScheduleList(crm_id: number): Promise<RequestResult<WorkScheduleListResp>> {
        const result = await this.get<WorkScheduleListResp>(`/work-schedules`, { crm_id });
        return result;
    }

    async getWorkSchedulesPerformerList({
        crm_id,
        workSheduleId,
        page,
        per_page = 10,
    }: {
        crm_id: number;
        workSheduleId: number;
        page: number;
        per_page: number;
    }): Promise<RequestResult<WorkScheduleListResp>> {
        const result = await this.get<WorkScheduleListResp>(
            `/work-schedules/${workSheduleId}/performers`,
            { crm_id, page, per_page }
        );
        return result;
    }

    async getWorkSchedulesResourcesList({
        crm_id,
        workSheduleId,
        page,
        per_page = 10,
    }: {
        crm_id: number;
        workSheduleId: number;
        page: number;
        per_page: number;
    }): Promise<RequestResult<WorkScheduleResourcesListResp>> {
        const result = await this.get<WorkScheduleResourcesListResp>(
            `/work-schedules/${workSheduleId}/resources`,
            { crm_id, page, per_page }
        );
        return result;
    }

    async updateWorkScheduleStatus(
        crm_id: number,
        entity_id: number,
        work_schedule_status_id: number
    ): Promise<RequestResult<WorkScheduleResp>> {
        const result = await this.post<WorkScheduleResp>(
            `work-schedules/${entity_id}/updateStatus`,
            {
                crm_id,
                work_schedule_status_id,
            }
        );
        return result;
    }

    async getWorkSchedulesPerformerListBulk(params: {
        crm_id: number;
        page: number;
        work_schedule_ids: number[];
        per_page: number;
    }): Promise<RequestResult<WorkScheduleListResp>> {
        const result = await this.post<WorkScheduleListResp>(
            `/work-schedules/performers/bulk`,
            params
        );
        return result;
    }

    async applyWorkScheduleStatusReason({
        workScheduleId,
        crm_id,
        reason_key,
        comment,
        prev_status_id,
        status_id,
        ...rest
    }: {
        workScheduleId: number;
        crm_id: number;
        reason_key: string;
        comment: string;
        prev_status_id?: number;
        status_id?: number;
    }): Promise<RequestResult<null>> {
        const result = await this.post<null>(`work-schedules/${workScheduleId}/apply-reason`, {
            crm_id,
            reason_key,
            comment,
            prev_status_id,
            status_id,
            ...rest,
        });
        return result;
    }
}

export { WorksScheduleGroup };
